import styled from 'styled-components'
import {
  space,
  width,
  fontSize,
  color,
  textAlign,
  display,
  maxWidth,
  minWidth,
  height,
  maxHeight,
  minHeight,
  alignItems,
  alignSelf,
  justifyContent,
  flexWrap,
  flexDirection,
  flex,
  order,
  overflow,
  position,
  zIndex,
  gridGap,
  gridColumnGap,
  gridRowGap,
  gridColumn,
  gridRow,
  gridAutoFlow,
  gridAutoColumns,
  gridAutoRows,
  gridTemplateColumns,
  gridTemplateRows,
  gridTemplateAreas,
  gridArea,
  justifySelf,
  justifyItems,
  borderRadius,
  borderLeft,
  borderRight,
  borderTop,
  borderBottom,
  flexGrow,
  alignContent,
  overflowY,
} from 'styled-system'

const Box = styled.div(
  [],
  space,
  width,
  fontSize,
  color,
  textAlign,
  display,
  maxWidth,
  minWidth,
  height,
  maxHeight,
  minHeight,
  flex,
  order,
  overflow,
  position,
  zIndex,
  gridArea,
  borderRadius,
  borderLeft,
  borderRight,
  borderTop,
  borderBottom,
  overflowY
)

const Flex = styled(Box)`
  display: flex;
  ${alignItems}
  ${justifyContent}
  ${flexWrap}
  ${flexDirection}
  ${display}
  ${alignSelf}
  ${justifySelf}
  ${borderRadius}
  ${flexGrow}
  ${alignContent}
`

const Grid = styled(Box)`
  display: grid;
  ${alignItems}
  ${justifyContent}
  ${justifyItems}
  ${gridGap}
  ${gridColumnGap}
  ${gridRowGap}
  ${gridColumn}
  ${gridRow}
  ${gridAutoFlow}
  ${gridAutoColumns}
  ${gridAutoRows}
  ${gridTemplateColumns}
  ${gridTemplateRows}
  ${gridTemplateAreas}
  ${justifySelf}
`

export { Box, Flex, Grid }
